import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getDashboard = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_dashboard`
  );
  return data;
});
export const getUserDetails = catchAsync(async (email) => {
  const { data } = await axiosInstance.get(`/api/resource/User/${email}`);
  return data;
});
export const editUser = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(`/api/resource/User/${id}`, body);
  return data;
});
// export const getDashboard = catchAsync(async (id) => {
//   const { data } = await axiosInstance.get(
//     `/api/method/technoerp.services.summary_for_practitioner?practitioner_id=${id}`
//   );
//   return data;
// });
